import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    isReviewSubmitPage: boolean;
};

export const DispatchSetReviewSubmitPage: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/CheckoutReviewPage/SetisReviewSubmitPage",
        result: props.parameter.isReviewSubmitPage,
    });
};

export const chain = [DispatchSetReviewSubmitPage];

const setReviewSubmitPage = createHandlerChainRunner(chain, "setReviewSubmitPage");
export default setReviewSubmitPage;
